<template>
  <div id="app-container" ref="appContainer">
    <div id="app" :style="appStyle">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</template>
<script>
import { getLoginInfo } from '@/api/login'
import { Toast } from 'vant'
import { isAndroid, isIos, isWeiXinA, isWeiXin } from '@/utils'
import WXShare from '@/utils/share'
import { mapMutations } from 'vuex'
export default {
  name: 'HomeView',
  data() {
    return {
      sessionId: null,
      accessNum: null,
      channelId: null,
      loginInfo: null,
      appStyle: {},
      designWidth: 750, // 设计稿宽度
    }
  },
  created() {
    this.setScale()
    window.addEventListener('resize', this.setScale)
    // 微信分享
    if (isWeiXinA && !isWeiXin) {
      const wxshare = new WXShare()
      wxshare.setOptions()
    }
    const paramsString = window.location.href.split('?')[1]
    if (paramsString) {
      const paramslist = paramsString.split('&')
      paramslist.forEach(item => {
        const group = item.split('=')
        const key = group[0]
        const val = group[1]
        this[key] = val
      })
      this.sessionId && this.getLoginInfoRequest()
    } else if (isAndroid) {
      this.set_channelId('cd_20220516_503441')
      this.channelId = 'cd_20220516_503441'
      this.getAndroidAppLoginInfo()
    } else if (isIos) {
      this.set_channelId('cd_20220626_540692')
      this.channelId = 'cd_20220626_540692'
      this.getIosAppLoginInfo()
    } else { // h5 渠道
      // this.channelId = 'd8c7e4489ebb737ea2f2610ecf29ad1c'
      // this.set_channelId('d8c7e4489ebb737ea2f2610ecf29ad1c')
      this.channelId = 'cd_20220914_514144'
      this.set_channelId('cd_20220914_514144')
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScale)
  },
  methods: {
    setScale() {
      const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      const scale = deviceWidth / this.designWidth
      this.appStyle = {
        width: this.designWidth + 'px',
        transform: `scale(${scale})`,
        transformOrigin: 'left top',
        marginLeft: 'auto',
        marginRight: 'auto',
      }
    },
  },  
  methods: {
    ...mapMutations([
      'set_sessionId',
      'set_accessNum',
      'set_channelId',
      'set_phoneInfo'
    ]),
    getLoginInfoRequest() {
      Toast({ message: '加载中...', forbidClick: true })
      this.set_channelId(this.channelId)
      this.set_sessionId(this.sessionId)
      this.set_accessNum(this.accessNum)
      getLoginInfo({
        accessNum: this.accessNum,
        sessionId: this.sessionId
      })
        .then((res) => {
          if (res) {
            this.loginInfo = res
            this.set_phoneInfo(res.phoneInfo)
          }
        })
    },
    // APP获取登录信息
    getIosAppLoginInfo() {
      if (document.cookie) {
        let aCookie = document.cookie.split('; ')
        let result = aCookie.find(val => val.indexOf('cbn_info=') > -1)
        if (result) {
          let [sessionId, ,accessNumber, , , , , loginPhone = '', , ,vCode = '' ] = (result.split('='))[1].split(',')
          if (sessionId && accessNumber) {
            this.set_sessionId(sessionId)
            this.set_accessNum(accessNumber)
            this.sessionId = sessionId
            this.accessNum = accessNumber
            this.getLoginInfoRequest()
          }
        }
      }
    },
    getAndroidAppLoginInfo() {
      let loginInfo = window.prompt(JSON.stringify({type: 'token'}))
      if (loginInfo) {
        let { type='', data = {} } = JSON.parse(loginInfo)
        if (type === 'token') {
          const { sessionId = '', phoneInfo: { loginPhone = '' } } = data
          if (sessionId && loginPhone) {
            this.set_sessionId(sessionId)
            this.set_accessNum(loginPhone)
            this.sessionId = sessionId
            this.accessNum = loginPhone
            this.getLoginInfoRequest()
          }
        }
      }
    }
  },
}
</script>
<style lang="less" scoped>
#app-container {
  width: 100%;
  overflow-x: hidden;
  background-color: #F8F8FB;
}

#app {
  background-color: #F8F8FB;
  min-height: 100vh;
  position: relative;
}
</style>
